import React from 'react';
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';
import type {
  PayrollAdjustmentSortState,
  PayrollAdjustmentTableSortColumn,
} from './payrollAdjustmentListShared';

type PayrollAdjustmentSortableHeaderProps = {
  label: string;
  column: PayrollAdjustmentTableSortColumn;
  sort: PayrollAdjustmentSortState;
  onSort: (column: PayrollAdjustmentTableSortColumn) => void;
  align?: 'left' | 'right';
};

export function PayrollAdjustmentSortableHeader({
  label,
  column,
  sort,
  onSort,
  align = 'left',
}: PayrollAdjustmentSortableHeaderProps) {
  const active = sort.key === column;
  const Icon = !active ? ChevronsUpDown : sort.dir === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th
      scope="col"
      aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
      className={`sticky top-0 z-10 border-b border-app-border bg-app-surface-muted px-3.5 py-2.5 ${
        align === 'right' ? 'text-right' : 'text-left'
      }`}
    >
      <button
        type="button"
        onClick={() => onSort(column)}
        className={`group/sort inline-flex max-w-full items-center gap-1 text-xs font-medium transition-colors ${
          active ? 'text-app-text' : 'text-app-text-muted hover:text-app-text'
        } ${align === 'right' ? 'ml-auto justify-end' : ''}`}
      >
        <span className="truncate">{label}</span>
        <Icon
          className={`h-3.5 w-3.5 shrink-0 transition-opacity ${
            active ? 'opacity-100' : 'opacity-0 group-hover/sort:opacity-60'
          }`}
          aria-hidden
        />
      </button>
    </th>
  );
}
